import { render, staticRenderFns } from "./signsList.vue?vue&type=template&id=4a39b8f0&"
import script from "./signsList.vue?vue&type=script&lang=js&"
export * from "./signsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports